import React, {FunctionComponent, useContext, useEffect} from 'react';
import MapContext from '../map/MapContext';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import { jsPDF } from 'jspdf';


type geocodingProps = {
}

const PrintInteraction: FunctionComponent<geocodingProps> = (props) => {
    // @ts-ignore
    const {map} = useContext(MapContext);
    const dispatch = useAppDispatch();
    const printOrder=useAppSelector((state:any)=>state.configLayer.layerData.exportPdf);
    const selection=useAppSelector((state:any)=>state.configLayer.layerData.selection);
    const dims = {
        a0: [1189, 841],
        a1: [841, 594],
        a2: [594, 420],
        a3: [420, 297],
        a4: [297, 210],
        a5: [210, 148],
    };


    const printPdf=()=> {
        document.body.style.cursor = 'progress';

        const format = 'a4';
        const resolution = 150;
        const dim = dims[format];
        const width = Math.round((dim[0] * resolution) / 25.4);
        const height = Math.round((dim[1] * resolution) / 25.4);
        const size = map.getSize();
        const viewResolution = map.getView().getResolution();

        map.once('rendercomplete', function () {
            const mapCanvas = document.createElement('canvas');
            mapCanvas.width = width;
            mapCanvas.height = height;
            const mapContext2 = mapCanvas.getContext('2d');
            Array.prototype.forEach.call(
                document.querySelectorAll('.ol-layer canvas'),
                function (canvas) {
                    if (canvas.width > 0) {
                        const opacity = canvas.parentNode.style.opacity;
                        // @ts-ignore
                        mapContext2.globalAlpha = opacity === '' ? 1 : Number(opacity);
                        const transform = canvas.style.transform;
                        // Get the transform parameters from the style's transform matrix
                        const matrix = transform
                            .match(/^matrix\(([^\(]*)\)$/)[1]
                            .split(',')
                            .map(Number);
                            // Apply the transform to the export map context
                        CanvasRenderingContext2D.prototype.setTransform.apply(
                            mapContext2,
                            matrix,
                        );
                        // @ts-ignore
                        mapContext2.drawImage(canvas, 0, 0);
                    }
                },
            );
            // @ts-ignore
            mapContext2.globalAlpha = 1;
            // @ts-ignore
            mapContext2.setTransform(1, 0, 0, 1, 0, 0);
            const pdf = new jsPDF('landscape', undefined, format);
            pdf.addImage(
                mapCanvas.toDataURL('image/jpeg'),
                'JPEG',
                0,
                0,
                dim[0],
                dim[1],
            );
            const title=selection.length==1?selection.toString()+'.pdf':selection[0]+' und weitere.pdf';
            pdf.save(title);
            // Reset original map size
            map.setSize(size);
            map.getView().setResolution(viewResolution);
            document.body.style.cursor = 'auto';
        });

        // Set print size
        const printSize = [width, height];
        map.setSize(printSize);
        const scaling = Math.min(width / size[0], height / size[1]);
        map.getView().setResolution(viewResolution / scaling);
    };

    useEffect(() => {
        if (!map || Object.keys(map).length === 0) return;
        printPdf();
    }, [printOrder]);

    useEffect(()=>{
        console.log('print loaded')
    },[])

    return (
        // @ts-ignore
        <div>
        </div>);
};

export default PrintInteraction;
